module.exports = __webpack_public_path__ + "img/landings-bg.00ea844.jpg";